import * as yup from 'yup'

export const schemaSejaParceiro = yup.object().shape({
  nome: yup.string().required().min(3).max(100).label('Nome'),
  email: yup.string().email().required().label('Email'),
  telefone: yup.string().required().min(10).max(11).label('Telefone')
})
